import type { AxiosError } from "axios";

import type { DataAccessLevel } from "@helpers/api";

import type { ThunkActionCreator } from "..";
import type { JobConfig, NewJobParams } from "../../types/api";
import { actions } from "./actions";

// JOBS
export const getJobs: ThunkActionCreator =
  () =>
  async (dispatch, getState, { apiClient }) => {
    dispatch(actions.getJobs.request());

    try {
      const response = await apiClient.getJobs(getState().user.user);
      dispatch(actions.getJobs.success(response));
    } catch (err) {
      dispatch(actions.getJobs.failure(err as AxiosError<unknown, any>));
    }
  };

export const launchNewJob: ThunkActionCreator<
  NewJobParams & { dataAccessLevels?: DataAccessLevel[] }
> =
  (newJobParams: NewJobParams & { dataAccessLevels?: DataAccessLevel[] }) =>
  async (dispatch, _, { apiClient }) => {
    const {
      randomJobName,
      jobName,
      accountId,
      sourceData,
      imageId,
      useLab,
      cpu,
      mem,
      gpu,
      gpuMem,
      dataAccessLevels,
    } = newJobParams;
    if (!sourceData) {
      throw new Error("sourceData must be defined.");
    }
    const finalJobName = jobName || randomJobName;
    const dataName = finalJobName;
    // create new data object for job
    try {
      dispatch(actions.createDataObject.request());
      const dataObjResponse = await apiClient.createDataObject(
        accountId,
        dataName,
      );
      const artifactDataId = dataObjResponse.id;

      // create job with new data object
      dispatch(actions.createJob.request());
      const jobConfig: JobConfig = {
        jobName: finalJobName,
        sourceData,
        artifactDataId,
        dataFolderName: "data",
        imageId,
        useLab,
        cpu,
        mem,
        gpu,
        gpuMem,
        dataAccessLevels,
      };
      const response = await apiClient.submitNotebookJob(accountId, jobConfig);
      dispatch(actions.createJob.success(response));
    } catch (err) {
      dispatch(
        actions.createDataObject.failure(err as AxiosError<unknown, any>),
      );
      return Promise.reject(err);
    }
  };

export const retryJob: ThunkActionCreator<string> =
  (jobId: string) =>
  async (dispatch, _, { apiClient }) => {
    dispatch(actions.retryJob.request());

    try {
      const response = await apiClient.retryJob(jobId);
      dispatch(actions.retryJob.success(response));
    } catch (err) {
      dispatch(actions.retryJob.failure(err as AxiosError<unknown, any>));
    }
  };

//IDENTITY
export const getMe: ThunkActionCreator =
  () =>
  async (dispatch, _, { apiClient }) => {
    dispatch(actions.getMe.request());

    try {
      const response = await apiClient.getMe();
      dispatch(actions.getMe.success(response));
    } catch (err) {
      dispatch(actions.getMe.failure(err as AxiosError<unknown, any>));
    }
  };
